import { fetchPost, fetchPut, fetchGet, fetchDelete } from '@/utils/request'

export function getCommonNews(query){ //全国楼市资讯列表
    return fetchGet('/gateway/v1/common-news',query)
}
export function editCommonNews(id,query){ //编辑全国楼市资讯
    return fetchPut('/gateway/v1/common-news/' + id,query)
}
export function addCommonNews(query){ //新增全国楼市资讯
    return fetchPost('/gateway/v1/common-news',query)
}
export function getCommonNewsDetail(id){ //全国楼市详情
    return fetchGet('/gateway/v1/common-news/'+id)
}
export function deleteCommonNews(id){ //删除全国楼市
    return fetchDelete('/gateway/v1/common-news/'+id)
}
export function getCommonNewsIsRecycled(query){ //全国楼市移入/还原回收站
    return fetchPut('/gateway/v1/common-news/is_recycled',query)
}